import { ReactComponent as Profile } from "@assets/icons/profile_icon.svg";

const ProfileIcon = (props: any): JSX.Element => {
  return (
    <Profile
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default ProfileIcon;
